import React from 'react';
import { Col, Row } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../Pages/Constants';
import UserList from '../Components/Staff/StaffList.js';
import {FormattedMessage} from 'react-intl';


const StaffManagementMenu = (props) => {
  	const { classes } = props;

  	/**Component generating four tabs*/
  	return (
        <div className={classes.popup_background}>
            <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
                <div className="management-menu-popup" style={{ display: "flex", flexDirection: "column" }}>
                    <Row className="justify-content-md-end" style={{ flexShrink: 0, paddingBottom: "12px" }}>
                    	<Col style={{ fontWeight: "bold", fontSize: "clamp(1.25em, 4.5vw, 2.2em)" }}>
                    		<center>
                    		  	<FormattedMessage id="staff.title" defaultMessage="Staff" /> - {props.struct_info.struct_name}
                    		</center>
                    	</Col>
                    </Row>
                    <Row style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
                        <UserList accountInformation={props.accountInformation} structure_Id={props.structure_Id} staff_list={props.staff_list} load_staff={props.load_staff} subscription_info={props.subscription_info} />
                    </Row>
                    <Row>
                        <center>
                            <button onClick={props.cancelPopup} className="btn btn-danger">
                                <FormattedMessage id="button.close" defaultMessage="Close" />                                           
                            </button>
                        </center>
                    </Row>
                </div>
            </div>
    	</div>
    );
};
export default withStyles(Constants.styles)(StaffManagementMenu);